import { useState } from 'react';
export default function useLightbox() {
    const [image, setImage] = useState(undefined);
    const onLightboxElementClick = (e) => {
        const target = e.target;
        if (target.nodeName === 'IMG') {
            const imageElement = target;
            if (imageElement.src.length) {
                e.preventDefault();
                e.stopPropagation();
                setImage(imageElement);
            }
        }
    };
    const hide = () => setImage(undefined);
    return { image, onLightboxElementClick, hide };
}
//# sourceMappingURL=useLightbox.js.map